import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import { Input } from '../../lib/form/fields';
import { requiredField, compareField } from '../../lib/form/validators';

const ChangePasswordForm = ({ valid, handleSubmit, onSubmit, loading }, context) => {
  const [state, setState] = useState({ pwdUnmasked: false });
  const pwdMaskToggle = () => {
    setState({ pwdUnmasked: !state.pwdUnmasked });
  };
  return (
    <form onSubmit={handleSubmit(values => onSubmit(values))}>
      <div className="row">
        <div className="col-6">
          <Field
            name="password"
            type={state.pwdUnmasked ? 'text' : 'password'}
            label={context.t('CHANGE-PASSWORD-FORM.PASSWORD.LABEL')}
            placeholder={context.t('CHANGE-PASSWORD-FORM.PASSWORD.PLACEHOLDER')}
            component={Input}
            appendInput={
              <span
                className={`input-group-text ${state.pwdUnmasked ? 'text-primary' : ''}`}
                onClick={() => pwdMaskToggle()}
              >
                <i className="fa fa-eye" />
              </span>
            }
          />
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <Field
            name="new_password"
            type={state.pwdUnmasked ? 'text' : 'password'}
            label={context.t('CHANGE-PASSWORD-FORM.NEW-PASSWORD.LABEL')}
            placeholder={context.t('CHANGE-PASSWORD-FORM.NEW-PASSWORD.PLACEHOLDER')}
            component={Input}
            appendInput={
              <span
                className={`input-group-text ${state.pwdUnmasked ? 'text-primary' : ''}`}
                onClick={() => pwdMaskToggle()}
              >
                <i className="fa fa-eye" />
              </span>
            }
          />
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <Field
            name="confirm_password"
            type={state.pwdUnmasked ? 'text' : 'password'}
            label={context.t('CHANGE-PASSWORD-FORM.PASSWORD-CONFIRM.LABEL')}
            placeholder={context.t('CHANGE-PASSWORD-FORM.PASSWORD-CONFIRM.PLACEHOLDER')}
            component={Input}
            appendInput={
              <span
                className={`input-group-text ${state.pwdUnmasked ? 'text-primary' : ''}`}
                onClick={() => pwdMaskToggle()}
              >
                <i className="fa fa-eye" />
              </span>
            }
          />
        </div>
      </div>

      <button type="submit" className="btn btn-primary mb-3" disabled={!valid}>
        {context.t('CHANGE-PASSWORD-FORM.BUTTON.SUBMIT')}
        {loading && (
          <div className="spinner-border spinner-border-sm ml-2" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        )}
      </button>
    </form>
  );
};

ChangePasswordForm.contextTypes = {
  t: PropTypes.func.isRequired,
};

const changePasswordFormValidator = formProps => {
  const errors = {};
  requiredField(formProps, errors, 'password', 'CHANGE-PASSWORD-FORM.PASSWORD.ERROR_REQUIRED');
  compareField(
    formProps,
    errors,
    'confirm_password',
    'new_password',
    'CHANGE-PASSWORD-FORM.PASSWORD-CONFIRM.ERROR_MISMATCH'
  );
  return errors;
};

export default reduxForm({
  form: 'ChangePasswordForm',
  validate: changePasswordFormValidator,
})(ChangePasswordForm);
